const prefix = 'lumahealth/DialogPatientMerge';

export const CLOSE_DIALOG = `${prefix}/CLOSE_DIALOG`;

export const FORM_NAME = 'DialogPatientMergeForm';

export const MERGE_PATIENTS = `${prefix}/MERGE_PATIENTS`;
export const MERGE_PATIENTS_ERROR = `${prefix}/MERGE_PATIENTS_ERROR`;
export const MERGE_PATIENTS_SUCCESS = `${prefix}/MERGE_PATIENTS_SUCCESS`;

export const OPEN_DIALOG = `${prefix}/OPEN_DIALOG`;

export const SEARCH_PATIENTS = `${prefix}/SEARCH_PATIENTS`;
export const SEARCH_PATIENTS_ERROR = `${prefix}/SEARCH_PATIENTS_ERROR`;
export const SEARCH_PATIENTS_SUCCESS = `${prefix}/SEARCH_PATIENTS_SUCCESS`;
